import { render, staticRenderFns } from "./DeviceStatusItem.vue?vue&type=template&id=3ddbd984&scoped=true"
import script from "./DeviceStatusItem.vue?vue&type=script&lang=ts"
export * from "./DeviceStatusItem.vue?vue&type=script&lang=ts"
import style0 from "./DeviceStatusItem.vue?vue&type=style&index=0&id=3ddbd984&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbd984",
  null
  
)

export default component.exports